import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Divider from "@material-ui/core/Divider";
import MuiAlert from "@material-ui/lab/Alert";

import Loader from "react-loader-spinner";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";

import credentials from "../environments/credentials";
import Grid from "@material-ui/core/Grid";


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0, 2),
    "& .MuiTextField-root": {
      margin: 0,
    },
  },
  formInner: {
    maxWidth: 520,
    margin: "0 auto",
  },
  wrapper: {
    boxShadow: "0 6px 2px 0 rgba(0,0,0,0.08)",
    paddingBottom: "64px",
  },
  title: {
    fontWeight: "bold",
    marginTop: "64px",
    marginBottom: "20px",
  },
  label: {
    fontSize: "95%",
  },
  center: {
    textAlign: "center",
  },
}));


const WhiteTextTypography = withStyles({
  root: {
    color: "#9fa0a0",
  },
})(Typography);

export default function ConsultationBookingForm({
  title = "Book a FREE consultation",
  siteID = "core",
}) {
  const classes = useStyles();

  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");

  const [open, setOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState("success");
  const [notificationMessage, setNotificationMessage] = React.useState(
    "Form submitted! Our team will contact you."
  );

  const { promiseInProgress } = usePromiseTracker();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  function validateContact(value) {
    const re =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(value);
  }

  function validateEmail(value) {
    const re =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(value);
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!name || !phone || !email) {
      setOpen(true);
      setSeverity("error");
      setNotificationMessage("All fields are required");
      return;
    }

    if (!validateContact(phone)) {
      setOpen(true);
      setSeverity("error");
      setNotificationMessage("Enter a valid contact number");
      return;
    }

    if (!validateEmail(email)) {
      setOpen(true);
      setSeverity("error");
      setNotificationMessage("Enter a valid email address");
      return;
    }

    const payload = {
      q: name,
      c: phone,
      e: email,
      siteID,
    };

    const apiEndPoint = `${credentials.API_URL}/contact-form/`;

    const request = fetch(apiEndPoint, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });

    trackPromise(
      request.then((response) => {
        if (response.status === 200) {
          setName("");
          setPhone("");
          setEmail("");
          setOpen(true);
          setSeverity("success");
          setNotificationMessage("Form submitted! Our team will contact you.");
        } else {
          setOpen(true);
          setSeverity("error");
          setNotificationMessage(
            "Something went wrong submitting the form. Please try again."
          );
        }
        return response;
      })
    );
  };


  const vertical = "top";
  const horizontal = "center";

  return (
    <div className={classes.wrapper}>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={severity}>
          {notificationMessage}
        </Alert>
      </Snackbar>

      <WhiteTextTypography
        component="h2"
        variant="h5"
        align="center"
        className={classes.title}
      >
        {title}
      </WhiteTextTypography>

      <Divider variant="middle" style={{ marginBottom: "40px" }} />

      <form
        onSubmit={handleSubmit}
        className={classes.root}
        noValidate
        autoComplete="off"
      >
        <div className={classes.formInner}>
          <Grid container spacing={2}>
            {/* Name */}
            <Grid item xs={12} sm={6}>
              <TextField
                id="consultation-name"
                label="Your Name"
                value={name}
                variant="outlined"
                fullWidth
                onChange={(e) => setName(e.target.value)}
                InputProps={{ style: { backgroundColor: "#ffffff" } }}
                InputLabelProps={{ classes: { root: classes.label } }}
              />
            </Grid>

            {/* Phone */}
            <Grid item xs={12} sm={6}>
              <TextField
                id="consultation-phone"
                label="Phone Number"
                value={phone}
                variant="outlined"
                fullWidth
                onChange={(e) => setPhone(e.target.value)}
                InputProps={{ style: { backgroundColor: "#ffffff" } }}
                InputLabelProps={{ classes: { root: classes.label } }}
              />
            </Grid>

            {/* Email (full width always) */}
            <Grid item xs={12}>
              <TextField
                id="consultation-email"
                label="Email Address"
                type="email"
                value={email}
                variant="outlined"
                fullWidth
                onChange={(e) => setEmail(e.target.value)}
                InputProps={{ style: { backgroundColor: "#ffffff" } }}
                InputLabelProps={{ classes: { root: classes.label } }}
              />
            </Grid>

            {/* Button */}
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Button
                style={{ marginTop: "10px" }}
                type="submit"
                variant="contained"
                color="secondary"
                disabled={promiseInProgress}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </div>
      </form>


      {promiseInProgress && (
        <div
          style={{
            width: "100%",
            height: "100",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          <Loader type="ThreeDots" color="#2BAD60" height="60" width="60" />
        </div>
      )}
    </div>
  );
}
